<div  role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Alert</h2>
      </div>
      <div class="modal-body">
        
        <ul class="popup-list">
            <li *ngFor="let d of data.popups">{{d}}</li>
        </ul>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>